import { styled } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { useKeycloak } from '@react-keycloak/web';
import { Navigate } from 'react-router-dom';
import FusePageSimple from '../../../../../@fuse/core/FusePageSimple';
import Document from './index';
import { getKeycloakRole } from '../../../../shared-components/utils';

const Root = styled(FusePageSimple)(({ theme }) => ({
  '& .FusePageSimple-header': {
    backgroundColor: theme.palette.background.paper,
    borderBottomWidth: 1,
    borderStyle: 'solid',
    borderColor: theme.palette.divider,
  },
  '& .FusePageSimple-toolbar': {},
  '& .FusePageSimple-content': {},
  '& .FusePageSimple-sidebarHeader': {},
  '& .FusePageSimple-sidebarContent': {},
}));

function CreateDocument(props) {
  const { t } = useTranslation('examplePage');

  const { keycloak } = useKeycloak();
  const roleKeycloak = getKeycloakRole(keycloak?.realmAccess?.roles);

  return (
    <>
      {['NOC', 'Administrador', 'Usuario', 'Monitoreo'].includes(roleKeycloak) ? (
        <Root
          content={
            <div className="p-24">
              <Document />
            </div>
          }
          scroll="content"
        />
      ) : (
        <Navigate to="/404" />
      )}
    </>
  );
}

export default CreateDocument;
